module.exports = __webpack_public_path__ + "static/gingerman-c4ae47e5d8293dfaa03f483b832be5d6.png";